/**
 * legacy app 専用 color tokens.
 *
 * 旧 kakeru UI が依存する MUI default + ADR-0045 セマンティックカラーパレット.
 * apps/legacy/ 配下のみ参照可. apps/latest/ からは参照不可 (= R2 物理分離).
 *
 * 一次情報: 旧 colorTokens.legacy.ts (= log/33 P3 cleanup で canonical 側に一旦 merge,
 *           本 file で apps/legacy/ に物理分離).
 */
export const colorTokens = {
  blue: {
    50: '#E3F2FD',
    100: '#BBDEFB',
    200: '#90CAF9',
    300: '#64B5F6',
    400: '#42A5F5',
    500: '#2196F3',
    600: '#1976D2',
    700: '#1565C0',
    800: '#0D47A1',
    900: '#0D47A1',
  },

  grey: {
    50: '#FAFAFA',
    100: '#F5F5F5',
    200: '#EEEEEE',
    300: '#E0E0E0',
    400: '#BDBDBD',
    500: '#9E9E9E',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
  },

  text: {
    primary: '#2C2C2C',
    secondary: '#757575',
    disabled: '#9E9E9E',
  },

  background: {
    page: '#F5F5F5',
    paper: '#FFFFFF',
    subtle: '#FAFAFA',
  },

  status: {
    success: '#4CAF50',
    successLight: '#E8F5E9',
    error: '#D00000',
    errorLight: '#FFEBEE',
    warning: '#FF9800',
    warningLight: '#F1CFCF',
    info: '#2196F3',
    declined: '#D32F2F',
    declinedBg: '#FFEBEE',
    declinedHover: '#FFCDD2',
  },

  action: {
    primaryBgLight: 'rgba(25, 118, 210, 0.04)',
    primaryBgHover: 'rgba(25, 118, 210, 0.08)',
    secondaryBgLight: 'rgba(158, 158, 158, 0.04)',
    secondaryBgHover: 'rgba(158, 158, 158, 0.08)',
  },

  special: {
    selected: '#D9E5FF',
    selectedHover: '#b8c9fa',
    highlight: '#F5F9FF',
    appliedBackground: '#F0F8FF',
    normalText: '#666666',
    selectedText: '#333333',
    micIcon: '#80a7e8',
    genderMale: '#1976d2',
    genderFemale: '#F8BBD0',
    fabHover: '#0D47A1',
    changeNegative: '#F44336',
    aiImprovement: '#F57C00',
    recordingBackground: '#e8f4ff',
    aiUncertain: '#A1A3A6',
    pureBlack: '#000000',
  },

  chart: {
    purple: '#9C27B0',
    cyan: '#00BCD4',
  },

  patient: {
    normal: '#E8F4FD',
    hover: '#D1E9FF',
  },

  soapType: {
    S: '#e3f2fd',
    O: '#e8f5e9',
    A: '#fff8e1',
    OP: '#ffebee',
    EP_CP: '#f3e5f5',
    default: '#f5f5f5',
  },

  border: {
    light: '#E0E0E0',
    medium: '#BDBDBD',
  },

  shadow: {
    card: '0 1px 3px rgba(0, 0, 0, 0.1)',
    cardHover: '0 4px 12px rgba(0, 0, 0, 0.15)',
  },
} as const

export type ColorTokens = typeof colorTokens
